import React from 'react';
import { Info } from 'lucide-react';
interface SettingsCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  infoTooltip?: string;
}
export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  children,
  infoTooltip
}) => {
  return <div className="p-6 border-b border-gray-200 dark:border-gray-800" data-id="element-18950">
      <div className="mb-4" data-id="element-18951">
        <div className="flex items-center gap-2" data-id="element-18952">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-18953">
            {title}
          </h3>
          {infoTooltip && <div className="relative group" data-id="element-18954">
              <Info size={16} className="text-gray-400 cursor-help" data-id="element-18955" />
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10" data-id="element-18956">
                {infoTooltip}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" data-id="element-18957"></div>
              </div>
            </div>}
        </div>
        {description && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-18958">
            {description}
          </p>}
      </div>
      <div data-id="element-18959">{children}</div>
    </div>;
};